import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtm from 'vue-gtm';

import store from './store';
import beforeEach from './routes/beforeEach';

import LoginPage from './components/pages/LoginPage.vue';
import RegistrationPage from './components/pages/RegistrationPage.vue';
import RegistrationActivationPage from './components/pages/RegistrationActivationPage.vue';
import OnboardingPage from './components/pages/OnboardingPage.vue';
import MyAccountPage from './components/pages/MyAccountPage.vue';
import UpdateDetailsPage from './components/pages/UpdateDetailsPage.vue';
import ChangeEmailPage from './components/pages/ChangeEmailPage.vue';
import ChangePasswordPage from './components/pages/ChangePasswordPage.vue';
import ResetPasswordPage from './components/pages/ResetPasswordPage.vue';
import CreatePasswordPage from './components/pages/CreatePasswordPage.vue';
import ErrorPage from './components/pages/ErrorPage.vue';
import LogoutPage from './components/pages/LogoutPage.vue';
import SocialLoginPage from './components/pages/SocialLoginPage.vue';
import SubscriptionsPage from './components/pages/SubscriptionsPage.vue';
import OffersPage from "./components/pages/OffersPage";
import OneClickCallbackPage from './components/pages/OneClickCallbackPage.vue';
import OAuthCallbackPage from './components/pages/OAuthCallbackPage.vue';

import GuardsCheck from './routes/GuardsCheck';
import guestRoute from './routes/guestRoute';
import userRoute from './routes/userRoute';
import logoutRoute from './routes/logoutRoute';
import socialUserRoute from './routes/socialUserRoute';
import FanOfferOptinPage from "./components/pages/FanOfferOptinPage";
import EoiThankYouPage from "./components/pages/EoiThankYouPage";
import EoiOptInPage from "./components/pages/EoiOptInPage";

Vue.use(VueRouter);
const router = new VueRouter({
	mode: 'history',
	routes: [{
		name: 'login',
		path: '/',
		props: true,
		component: LoginPage,
		beforeEnter: guestRoute,
		meta: {gtm: 'LoginPage'}
	}, {
		name: 'register',
		path: '/register',
		props: true,
		component: RegistrationPage,
		beforeEnter: guestRoute,
		meta: {gtm: 'RegisterPage'}
	}, {
		name: 'verify',
		path: '/register/verify',
		props: false,
		component: RegistrationActivationPage,
		beforeEnter: guestRoute,
		meta: {gtm: 'VerifyRegistrationActivationPage'}
	}, {
		name: 'resend',
		path: '/register/verify/resend',
		props: false,
		component: RegistrationActivationPage,
		beforeEnter: guestRoute,
		meta: {gtm: 'ResendRegistrationActivationPage'}
	}, {
		name: 'createPassword',
		path: '/reset-password/new',
		component: CreatePasswordPage,
		props: true,
		meta: {gtm: 'ResendRegistrationActivationPage'}
	}, {
		name: 'resetPassword',
		path: '/reset-password',
		props: true,
		component: ResetPasswordPage,
		meta: {gtm: 'ResetPasswordPage'}
	}, {
		name: 'myAccount',
		path: '/my-account',
		component: MyAccountPage,
		props: true,
		beforeEnter: userRoute,
		meta: {gtm: 'MyAccountPage'}
	}, {
		name: 'callbackOneClick',
		path: '/callback-oneclick',
		component: OneClickCallbackPage,
		meta: {gtm: 'OneClickCallbackPage'}
	}, {
		name: 'fan-offer',
		path: '/fan-offer',
		props: true,
		component: FanOfferOptinPage
	}, {
		name: 'eoi',
		path: '/eoi',
		props: true,
		component: EoiOptInPage
	}, {
		name: 'thank-you',
		path: '/thank-you',
		props: true,
		component: EoiThankYouPage
	}, {
		name: 'updateDetails',
		path: '/my-account/update-details',
		component: UpdateDetailsPage,
		// beforeEnter: GuardsCheck([userRoute, socialUserRoute])
		beforeEnter: userRoute,
		meta: {gtm: 'UpdateDetailsPage'}
	}, {
		name: 'onBoarding',
		path: '/my-account/preferences',
		component: OnboardingPage,
		beforeEnter: userRoute,
		meta: {gtm: 'OnBoardingPage'}
	}, {
		name: 'changeEmail',
		path: '/my-account/change-email',
		component: ChangeEmailPage,
		beforeEnter: GuardsCheck([userRoute, socialUserRoute]),
		meta: {gtm: 'ChangeEmailPage'}
	}, {
		name: 'changePassword',
		path: '/my-account/change-password',
		component: ChangePasswordPage,
		beforeEnter: GuardsCheck([userRoute, socialUserRoute]),
		meta: {gtm: 'ChangePasswordPage'}
	}, {
		name: 'error',
		path: '/error',
		props: route => ({
			message: route.query.message,
		}),
		component: ErrorPage,
	}, {
		name: 'logout',
		path: '/logout',
		component: LogoutPage,
		beforeEnter: logoutRoute,
		meta: {gtm: 'LogoutPage'}
	}, {
		name: 'idpresponse',
		path: '/idpresponse.html',
		component: SocialLoginPage,
		beforeEnter: guestRoute,
		meta: {gtm: 'SocialLoginPage'}
	}, {
		name: 'oauthCallback',
		path: '/oauth/callback',
		component: OAuthCallbackPage,
		meta: {gtm: 'OAuthCallbackPage'}
	}, {
		name: 'subscriptions',
		path: '/subscriptions/:contactId',
		props: route => ({
			contactId: route.params.contactId,
		}),
		component: SubscriptionsPage,
		meta: {gtm: 'SubscriptionsPage'}
	}, {
		name: 'offers',
		path: '/offers',
		component: OffersPage,
		beforeEnter: userRoute,
		meta: {gtm: 'OffersPage'}
	}]
});

router.beforeEach(beforeEach);

router.afterEach(() => {
	store.dispatch('CHANGE_LOADING_STATE', false);
});
	
if (GtmKey) {
	Vue.use(VueGtm, {
		id: GtmKey,
		vueRouter: router,
	});
}

export default router;
